module.exports = __webpack_public_path__ + "static/Heap-22eb1c12f9959bcf544c25c41ddc5a77.png";